<template>
  <div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      closeable
      :style="{ height: '85%' }"
    >
      <BuyNoticePopup
        :noticeInfo="noticeInfo"
        :purchaseType="product.purchaseType === 1"
        :skuName="product.skuName"
      />
    </van-popup>

    <div class="product" v-if="product.skuId">
      <div class="product-info showTitle" v-if="showTitle">
        <img
          class="icon_prefer_prod"
          src="~@/assets/images/order/icon_prefer_prod.png"
          alt=""
          v-if="isCustomisedGoods"
        />
        <span>{{ isCustomisedGoods ? '孕产优选' : '服务商品' }}</span>
      </div>
      <div class="product-info" v-else>
        <i></i>
        <div class="title pf-medium">{{ product.businessName }}</div>
        <div class="item-cell-ft" v-if="orderStatus !== -1">
          {{ stateDesc }}
        </div>
      </div>
      <div class="item-cell product-detail">
        <div class="img-ui">
          <img :src="product.cmmdtyImage | viewImage(200, 120)" alt="" />
        </div>
        <div class="content-ui">
          <div class="f-l">
            <p class="name">
              <span>{{ product.spuName }}</span>
              <span v-html="price"></span>
            </p>
            <p class="specification">产品规格：{{ product.skuName }}&nbsp;</p>
          </div>
          <div class="l-l">
            <p v-if="isTripTicket601" class="labels">
              <span v-if="noticeInfo && ticketRefund">{{ ticketRefund }}</span>
              <span v-if="noticeInfo && ticketChange">{{ ticketChange }}</span>
              <span
                v-if="noticeInfo"
                @click="goTicketTerms"
                style="color: #348be6"
                >购买须知<i class="icon-arrow-right"></i
              ></span>
            </p>
            <p v-else class="labels">
              <span
                v-if="product.isAnyTimeRefund === 1"
                @click="anyTimeRefundAction"
                >随时退</span
              >
              <span
                v-if="product.isExpiredRefund === 1"
                @click="expiredRefundAction"
                >过期退</span
              >
              <span
                class="no-refund"
                v-if="
                  product.isAnyTimeRefund === 0 && product.isExpiredRefund === 0
                "
                >不可退</span
              >
              <span v-if="product.isPosPay * 1 === 1">POS支付</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { E_SKUTAG } from '@/config'
import { Msgbox } from 'kf-component-vue'
import { SKUTAG } from '@/plugins/enum'
import { Popup } from 'vant'
import BuyNoticePopup from './notice/BuyNoticePopup.vue'
import { queryBookingNotes } from './notice/service'
import { mapState } from 'vuex'
export default {
  components: {
    [Popup.name]: Popup,
    BuyNoticePopup
  },
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    priceInfo: {
      type: Object,
      default: () => {}
    },
    orderStatus: {
      type: Number,
      default: -1
    },
    stateDesc: {
      type: String,
      default: ''
    },
    couponInfo: {
      type: Array,
      default: () => []
    },
    isCustomisedGoods: {
      type: Boolean
    }
  },
  data() {
    return {
      show: false,
      noticeInfo: null
    }
  },
  async mounted() {
    if (this.isTripTicket601) {
      const result = await queryBookingNotes(this.product.skuId)
      this.noticeInfo = result
    }
  },
  methods: {
    goTicketTerms() {
      this.show = true
    },
    async goTerms() {
      const domain = '//m.czj100.com'
      location.href = `${domain}/details/guides/ticket/${this.product.skuId}`
    },
    anyTimeRefundAction() {
      Msgbox({
        title: '随时退',
        message:
          '您所购买的服务如未核销未使用随时可退款，3个工作日内完成退款审核'
      })
    },
    expiredRefundAction() {
      Msgbox({
        title: '过期退',
        message: '您所购买的服务如未核销未使用，过期后将自动退款至您的支付账户'
      })
    }
  },
  computed: {
    ...mapState(['isSupportScore']),
    ticketRefund() {
      if ('1' == this.noticeInfo.isAnyTimeRefund) {
        return '随时退'
      } else if ('0' == this.noticeInfo.isAnyTimeRefund) {
        return '不可退'
      }
      return ''
    },
    ticketChange() {
      if ('1' == this.noticeInfo.changeTicket) {
        return '需换票'
      } else if ('0' == this.noticeInfo.changeTicket) {
        return '无需换票'
      }
      return ''
    },
    price() {
      if (this.isSupportScore) {
        return `${this.priceInfo.payScore}积分`
      } else if (this.priceInfo.price) {
        return `<i>&yen;</i>${this.priceInfo.price / 100}`
      }
    },
    showTitle() {
      const { skuTag } = this.product
      return +skuTag === E_SKUTAG.POPTRAIN || +skuTag === E_SKUTAG.POPSTORE
    },
    isTripTicket601() {
      return (
        this.product &&
        this.product.skuTag === SKUTAG.TICKET &&
        this.product.skuSecType === 601
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
/deep/.van-popup__close-icon {
  color: #666;
  font-size: rem(40px);
}
.product {
  margin-bottom: rem(20px);
  border-radius: rem(16px);
  overflow: hidden;
  padding: rem(20px) 0;
  background-color: #fff;
  .product-info {
    padding-bottom: 0;
    height: rem(70px);
    padding: 0 rem(24px);
    display: flex;
    align-items: center;
    &.showTitle {
      font-size: 0.3rem;
      color: #121212;
      font-weight: 600;

      .icon_prefer_prod {
        margin: 0 rem(10px) 0 rem(10px);
        width: rem(26px);
        height: rem(32px);
      }
    }
    > i {
      width: rem(30px);
      height: rem(30px);
      margin-right: rem(10px);
      background: url('~@/assets/images/icon-bus_icon@3x.png') no-repeat;
      background-size: rem(30px) auto;
    }
    .title {
      font-size: rem(26px);
      color: #262626;
      flex: 1;
      @include tellicpsis;
    }
  }
  .settlement {
    margin-top: rem(20px);

    .price {
      i {
        margin-right: rem(5px);
      }
    }
  }
  .coupon-ui {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .chooseCoupon {
    display: flex;
    align-items: center;
    &.hasCoupon {
      padding-right: 0;
      > p {
        background: #fff5f8;
        font-size: rem(22px);
        color: #ff5900;

        line-height: rem(32px);
        padding: 0 rem(10px);
        @include border(all, #ff8800, 1px, 2px);
      }
    }
    p {
      flex: 1;
      text-align: right;
    }

    .default {
      color: #262626;
      text-align: right;
      font-weight: normal;
      font-size: rem(26px);
    }
    .haveCoupon {
      color: #262626;
      font-size: rem(26px);
    }
  }
  .discount {
    padding-top: rem(20px);
    padding-bottom: 0;
  }
  .amount {
    .price {
      color: #ff5900;
      font-weight: 600;
      i {
        margin-right: rem(5px);
      }
    }
    .item-cell-bd {
      font-size: rem(32px);
    }
  }
  .product-detail {
    display: flex;

    align-items: stretch;
    padding: rem(20px) rem(24px);
    .img-ui {
      flex: none;
      border-radius: rem(12px);
      overflow: hidden;
      width: rem(200px);
      height: rem(120px);
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .content-ui {
      flex: auto;
      padding-left: rem(20px);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .name {
      font-size: rem(28px);
      color: #262626;
      line-height: rem(38px);
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      span {
        &:first-child {
          @include ellicpsis;
        }
        &:last-child {
          flex: none;
          font-weight: bold;
          padding-left: rem(30px);
        }
      }
    }
    .specification {
      color: #999;
      margin-top: rem(4px);
      font-size: rem(22px);
    }
    .labels {
      font-size: rem(22px);
      line-height: rem(28px);
      color: #262626;
      display: flex;
      > span {
        display: inline-block;
        position: relative;
        padding-right: rem(20px);
        height: rem(28px);
        &.no-refund {
          color: #f5a623;
        }
        &::after {
          display: block;
          content: '';
          position: absolute;
          top: rem(2px);
          bottom: rem(4px);
          right: rem(10px);
          width: 1px;
          background-color: #262626;
        }
        &:last-child {
          padding-right: 0;
          &::after {
            width: 0;
          }
        }
      }

      i {
        margin-left: rem(4px);
        font-size: rem(24px);
      }
    }
  }
}
.roundclosefill-ui {
  width: rem(46px);
  height: rem(34px);
  background: url('~@/assets/images/icon-confirm-delete@3x.png') no-repeat
    center right;
  background-size: rem(34px) auto;
}
.y-e-ios {
  .product .product-info.showTitle {
    font-weight: 500;
  }
}
</style>
